<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card
      [title]="'personalContact.title' | translate"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content class="content">
        <ng-template [ngTemplateOutlet]="personalContactTemplate"></ng-template>
        <div actions class="navigationButtons">
          <button
            (click)="handleContinueButtonClick()"
            mat-flat-button
            color="primary"
          >
            {{ "global.continueButton" | translate }}
          </button>
          <button
            (click)="handleBackButtonClick()"
            mat-flat-button
            color="secondary"
          >
            {{ "global.backButton" | translate }}
          </button>
        </div>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <div left-content [formGroup]="personalContactForm" class="content">
        <ng-template [ngTemplateOutlet]="personalContactTemplate"></ng-template>
      </div>
    </div>
  </ng-template>

</div>

<ng-template #personalContactTemplate>
  <div [formGroup]="personalContactForm">

    <div class="checkbox-container">
      <app-checkbox
        [checkboxLabel]="'personalContact.checkboxLabel' | translate"
        [control]="personalContact"
      ></app-checkbox>
    </div>

    <div *ngIf="error" class="error">
      {{ error }}
    </div>

  </div>
</ng-template>
